<template>
  <div id="app">
    <div class="main-content">
      <div class="container column is-12">
        <nav-bar />
      </div>
      <div class="container column is-10">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";

export default {
  name: "app",
  data() {
    return {};
  },
  components: {
    NavBar
  },
  methods: {}
};
</script>

<style lang="sass">
@import '~bulma'
$fa-font-path: '~font-awesome/fonts/'
@import '~font-awesome/scss/font-awesome'
</style>
<style>
@import "./assets/css/bulmaswatch.min.css";
</style>


// WEBPACK FOOTER //
// src/App.vue